/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function ColorBlindAchromatomaly(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'ColorBlindAchromatomaly',
      'aria-hidden': true,
      focusable: false,
      width:  16 * scale,
      height: 16 * scale,
      viewBox: '0 0 16 16',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"d":"M11.97 5.7a4 4 0 0 1-.478 1.3H4.508a4 4 0 0 1-.478-1.3zM12 4.5a4 4 0 0 0-.4-1.3H4.4c-.204.4-.342.838-.4 1.3zM8 1a4.03 4.03 0 0 0-2.666 1h5.332C9.956 1.378 9.022 1 8 1","fill":"#FF424D"}),createElement('path', {"d":"M7.2 12.493 2.525 7.818a4 4 0 0 1 1.201-.637L7.2 10.655zm1.6-.163.02-.056-.02-.02zM1.698 8.688l5.614 5.614a4 4 0 0 1-1.257.581L1.117 9.945c.116-.443.31-.869.581-1.257m-.671 2.864a4.03 4.03 0 0 0 1.145 2.276 4.03 4.03 0 0 0 2.276 1.145z","fill":"#2FC862"}),createElement('path', {"d":"m8.8 12.572 4.732-4.732a4 4 0 0 0-1.199-.64L8.8 10.735v1.838zm-.01 1.708 5.57-5.57c.271.388.466.813.584 1.254l-4.9 4.9a4 4 0 0 1-1.255-.584zm2.855.68a4 4 0 0 0 2.263-1.132 4 4 0 0 0 1.132-2.262z","fill":"#2496FF"}))
}
